module.exports = __webpack_public_path__ + "static/media/intro-mobile2.2a834470.svg";